import React from 'react';

import { setShareModalMemory } from '../../helpers/memory';

import type { Memory } from '../../types/memory';

const MemorySharingEmail: React.FC<{ memory: Memory }> = ({ memory }) => {
  return (
    <wa-card className="memory-sharing-card memory-sharing-share-link" data-dialog="open share-modal" onClick={() => setShareModalMemory(memory.id)}>
      <div className="wa-flank wa-gap-0">
        <div className="wa-cluster">
          <div className="memory-sharing-icon">
            <i className="fa-light fa-envelope" />
          </div>
          <div className="memory-sharing-content">
            Email ({memory.available_shares} remaining)
          </div>
        </div>
        <div className="memory-sharing-arrow">
          <i className="fa-light fa-chevron-right fa-xs" />
        </div>
      </div>
    </wa-card>
  );
}

export default MemorySharingEmail;
